<template>
  <form action="javascript:void()" @submit.prevent="submit" novalidate autocomplete="off">
    <v-text-field
      v-model="formData.task"
      v-validate="'required'"
      :error-messages="errors.collect('task')"
      :label="dictionary.attributes.task"
      data-vv-name="task"
      required
    ></v-text-field>
    <v-text-field
      type="number"
      step="0.5"
      v-model="formData.hours"
      v-validate="'required|digits'"
      :error-messages="errors.collect('hours')"
      :label="dictionary.attributes.hours"
      data-vv-name="hours"
      required
    ></v-text-field>
    <div class="mt-5 d-flex">
      <v-spacer></v-spacer>
      <span v-if="!saving">
        <v-btn depressed text type="reset" @click="close">Clear</v-btn>
        <v-btn depressed color="accent" class="ml-2" type="submit">Add</v-btn>
      </span>
      <v-btn depressed color="accent" class="ml-2" disabled v-if="saving">
        <v-progress-circular indeterminate size="12" width="1" class="mr-1"></v-progress-circular>
        <span>Saving...</span>
      </v-btn>
    </div>
  </form>
</template>

<script>
export default {
  name: 'contact-form',

  $_veeValidate: {
    validator: 'new',
  },

  props: {
    formData: {
      type: Object,
      default() {
        return {
          name: '',
        };
      },
    },
  },

  data() {
    return {
      saving: false,
      dictionary: {
        attributes: {
          task: 'Your Task',
          hours: 'Hours Dedicated',
        },
      },
    };
  },

  computed: {},

  mounted() {
    this.$validator.localize('en', this.dictionary);
    this.autofocus = true;
  },

  methods: {
    submit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.saving = true;
          this[this.formData.id ? 'updateContact' : 'addContact'](this.formData)
            .then(() => {
              this.$emit('save');
            })
            .catch(() => {})
            .finally(() => {
              this.saving = false;
            });
        }
      });
    },
    close() {
      this.$emit('close');
    },
    clear() {
      this.$validator.reset();
    },
  },
};
</script>
